/**
 * @generated SignedSource<<06e0592fdd389849cb1566f991e5240b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BudgetPage_company$data = {
  readonly tier: TierType | null;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetPageHeader_company" | "BudgetData_company" | "Details_company">;
  readonly " $fragmentType": "BudgetPage_company";
};
export type BudgetPage_company$key = {
  readonly " $data"?: BudgetPage_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetPage_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetPage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetPageHeader_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BudgetData_company"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Details_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "b7d7f1135250d55dc50983cf868a5ec3";

export default node;
